import React, { useState, useEffect } from "react";
import { Tree } from "primereact/tree";
// import { classNames } from "primereact/utils";
import { TreeDataService } from "../../services/TreeDataService";
import {
  StatusIcon,
  Text,
  Search,
  Dropdown,
  MSpinner,
  Tooltip,
  Checkbox,
  MTag,
} from "@cisco/spaces-dash-lib-styleguide";
import "./lh-base.css";
import TickIcon from "../../assets/images/hierarchy-icons/tick.svg";
import ExpandIcon from "../../assets/images/hierarchy-icons/expand.svg";
import CollapseIcon from "../../assets/images/hierarchy-icons/collapse.svg";
import LeafIcon from "../../assets/images/hierarchy-icons/leaf.svg";
import RootIcon from "../../assets/images/hierarchy-icons/root.svg";
import CampusIcon from "../../assets/images/hierarchy-icons/campus.svg";
import OrgIcon from "../../assets/images/hierarchy-icons/org.svg";
import MerakiIcon from "../../assets/images/hierarchy-icons/meraki.svg";
import NetworkIcon from "../../assets/images/hierarchy-icons/network.svg";
import BuildingIcon from "../../assets/images/hierarchy-icons/building.svg";
import FloorIcon from "../../assets/images/hierarchy-icons/floor.svg";
import WLCIcon from "../../assets/images/hierarchy-icons/wlc.svg";
import ZoneIcon from "../../assets/images/hierarchy-icons/zone.svg";
import ApZoneIcon from "../../assets/images/hierarchy-icons/ap_zone.svg";
import GroupIcon from "../../assets/images/hierarchy-icons/group.svg";
import OutdoorAreaIcon from "../../assets/images/hierarchy-icons/outdoor-magnetic.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  updateSelectedLocation,
  setSelectedLocations,
  updateLocationRowMap,
  updateLocationWrap,
  updateLocationMongo,
} from "@cisco/spaces-dash-lib-redux-store";
import * as LocationService from "../../services/LocationService";

export default function SingleSelectionDemo(props) {
  const [nodes, setNodes] = useState([]);
  const [fullTreeData, setFullTreeData] = useState([]);
  const [, setParams] = useState({});
  const [selectionMode, setSelectionMode] = useState("plain");
  const [dummyTree, setDummyTree] = useState(false);
  const [selectedKey, setSelectedKey] = useState("");
  // const [selectedKeys, setSelectedKeys] = useState(null);
  const dispatch = useDispatch();
  const staticData = false;
  const userN = sessionStorage.getItem("userName")
    ? sessionStorage.getItem("userName")
    : sessionStorage.getItem("supportUserName");
  const userTenant = sessionStorage.getItem("tenantId") + userN;
  const [locationMap, setLocationMap] = useState({});
  const [expandedKeys, setExpandedKeys] = useState({});
  const [selectedLocationArray, setSelectedLocationArray] = useState([]);
  const [selectedParentLocationArray, setSelectedParentLocationArray] =
    useState([]);
  const [selectedLocationData, setSelectedLocationData] = useState([]);

  const [searchKey, setSearchKey] = useState("");
  const [apList, setApList] = useState([]);
  const [showApDropdown, setShowApDropdown] = useState(false);

  // const [indexeddbInterval, setIndexeddbInterval] = useState(null);
  const [deltaUpdateTime, setDeltaUpdateTime] = useState(new Date());
  const locationUpdate = useSelector((state) => state.locationUpdate);
  const userDetails = useSelector((state) => state.userDetails);
  const parsedLocationTree = useSelector((state) => state.parsedLocationTree);
  const [showTreeLoader, setShowTreeLoader] = useState(false);
  const [showAllLocations, setShowAllLocations] = useState(false);

  const [localPropsObject, setLocalPropsObject] = useState({});

  const [isSmartLicenseRegistered, setIsSmartLicenseRegistered] = useState(
    sessionStorage.getItem("isSmartLicenseRegistered") &&
      sessionStorage.getItem("isSmartLicenseRegistered") === "true"
      ? true
      : false
  );

  useEffect(() => {
    if (locationUpdate) {
      if (deltaUpdateTime < locationUpdate.lastUpdated) {
        setDeltaUpdateTime(locationUpdate.lastUpdated);
      }
      treeInit();
      setShowTreeLoader(true);
    }
  }, [locationUpdate]);

  useEffect(() => {
    if (
      userDetails &&
      userDetails.userCurrentStatus &&
      userDetails.userCurrentStatus.data
    ) {
      if (userDetails.userCurrentStatus.data.isSmartLicenseRegistered) {
        setIsSmartLicenseRegistered(true);
      } else {
        setIsSmartLicenseRegistered(false);
      }
    }
  }, [userDetails]);

  useEffect(() => {
    // console.log("Props", props);
    setParams(props.props);
    if (props.props && props.props.appName === "business-hierarchy") {
      window.selectedLocationId = null;
    }
    // treeInit();
  }, []);

  useEffect(() => {
    if (
      props.props.selectedLocations &&
      props.props.selectedLocations.length !== selectedLocationData.length
    ) {
      // console.log(
      //   "Change in props selectedLocations",
      //   props.props.selectedLocations
      // );
      if (props.props.dispatchUpdate) {
        preparePreselectedLocations(props.props.selectedLocations, true);
      } else {
        preparePreselectedLocations(props.props.selectedLocations, false);
      }
    }
    if (
      props.props &&
      props.props.showAllLocations !== undefined &&
      props.props.showAllLocations !== null &&
      props.props.showAllLocations !== showAllLocations
    ) {
      setShowAllLocations(props.props.showAllLocations);
      treeInit();
    }
  }, [props]);

  const treeInit = () => {
    const singleSelectTypes = ["single", "tick", "radio"];
    if (props.props && props.props.type) {
      if (singleSelectTypes.indexOf(props.props.type) > -1) {
        setSelectionMode("single");
      } else {
        setSelectionMode("");
      }
    } else {
      setSelectionMode("");
    }

    if (props.props.dummyTree) {
      // dummy tree for reports
      setDummyTree(true);
      TreeDataService.getDummyTreeNodes().then((data) => setNodes(data));
    } else if (staticData) {
      // static data for testing
      setDummyTree(false);
      TreeDataService.getTreeNodes().then((data) => setNodes(data));
    } else {
      setDummyTree(false);
      const indexeddbInterval = setTimeout(() => {
        getIndexedDbData();
      });
      return () => clearInterval(indexeddbInterval);
    }
  };

  const getIndexedDbData = () => {
    const dbName = "dashboardDB";
    const dbVersion = localStorage.getItem("dbVersion")
      ? localStorage.getItem("dbVersion")
      : 1;
    const request = indexedDB.open(dbName, dbVersion);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      const storeName = "locationMap";
      db
        .transaction(storeName)
        .objectStore(storeName)
        .get(userTenant).onsuccess = (event) => {
        // console.log(`${userTenant} is ${event.target.result}`);
        setLocationMap(event.target.result);
      };
    };

    request.onsuccess = function (event) {
      let db = event.target.result;
      let transaction = db.transaction("locationMap", "readwrite");
      let objectStore = transaction.objectStore("locationMap");
      objectStore.get(userTenant).onsuccess = (event) => {
        setLocationMap(event.target.result);
      };
    };
  };

  useEffect(() => {
    setShowTreeLoader(false);
    prepareTreeData();
  }, [locationMap]);

  // Recursive function to filter the tree based on RBAC
  const prepareRBACAccessTree = (node) => {
    if (!node.children || node.children.length === 0) {
      // If the node has no children, include it only if access is "Full"
      return node.access === "Full" ? { ...node, children: [] } : null;
    }

    // Recursively filter the children
    const filteredChildren = node.children
      .map(prepareRBACAccessTree)
      .filter((child) => child !== null);

    // Include the node if it has "Full" access or any filtered children
    if (node.access === "Full" || filteredChildren.length > 0) {
      return { ...node, children: filteredChildren };
    }

    // Otherwise, exclude the node
    return null;
  };

  const prepareTreeData = () => {
    if (
      locationMap &&
      locationMap.data &&
      locationMap.data.size &&
      locationMap.rootLocationId
    ) {
      let expandedObj = {};
      expandedObj[locationMap.rootLocationId] = "true";
      if (expandedKeys && Object.keys(expandedKeys).length) {
        // do nothing
      } else {
        setExpandedKeys(expandedObj);
      }
      let treeObj = {};
      const fullTree = prepareRecursiveTree(
        locationMap.rootLocationId,
        treeObj,
        "full"
      );
      setFullTreeData([fullTree]);
      const finalTree = prepareRecursiveTree(
        locationMap.rootLocationId,
        treeObj,
        "appLevel"
      );
      const mongoObj = prepareMongoObj(locationMap.data);
      if (props.props && props.props.filterLocationId) {
        let rootObj = {};
        const filteredTree = prepareRecursiveTree(
          props.props.filterLocationId,
          treeObj,
          "full"
        );

        if (
          props.props &&
          props.props.filterLocationId !== locationMap.rootLocationId
        ) {
          rootObj = locationMap.data.get(locationMap.rootLocationId);
          rootObj["children"] = [filteredTree];
        } else {
          rootObj = filteredTree;
        }

        if (props.props && props.props.appName === "business-hierarchy") {
          setNodes([rootObj]);
        } else if (props.props.showAllLocations) {
          setNodes([rootObj]);
        } else {
          const rbacAccessTree = prepareRBACAccessTree(rootObj);
          if (rbacAccessTree) {
            setNodes([rbacAccessTree]);
          } else {
            // all locations are read only. So give all locations
            setNodes([rootObj]);
          }
        }
      } else {
        if (props.props && props.props.appName === "business-hierarchy") {
          setNodes([finalTree]);
        } else if (props.props.showAllLocations) {
          setNodes([finalTree]);
        } else {
          const rbacAccessTree = prepareRBACAccessTree(finalTree);
          if (rbacAccessTree) {
            setNodes([rbacAccessTree]);
          } else {
            // all locations are read only. So give all locations
            setNodes([finalTree]);
          }
        }
      }
      const mapObj = mapToObject(locationMap.data);
      setTimeout(() => {
        dispatch(updateLocationRowMap(mapObj));
        dispatch(updateLocationMongo(mongoObj.mongoMap));
        // dispatch(updateLocationMongoData(mongoObj.mongoLocationMap));
      }, 100);
    }
  };

  const mapToObject = (map) => Object.fromEntries(map.entries());

  const prepareMongoObj = (locMap) => {
    const mongoMapObj = {};
    const mongoLocationMapObj = {};
    if (locMap && locMap.size) {
      for (let [locId, locObj] of locMap) {
        if (locObj.mongoId) {
          mongoMapObj[locObj.mongoId] = locId;
          mongoLocationMapObj[locObj.mongoId] = locObj;
        } else if (locObj.mongoLocationId) {
          mongoMapObj[locObj.mongoLocationId] = locId;
          mongoLocationMapObj[locObj.mongoLocationId] = locObj;
        }
      }
    }
    return {
      mongoMap: mongoMapObj,
      mongoLocationMap: mongoLocationMapObj,
    };
  };

  useEffect(() => {
    console.log("LH Tree init with props::", props.props);
    if (props.props && props.props.appName === "business-hierarchy") {
      setExpandedKeys({});
    }
  }, []);

  useEffect(() => {
    console.log("LH Tree init with props::", props.props);
    if (props.callback !== undefined && props.callback !== null) {
      console.log("LH Tree called with callback:: ", true);
    } else {
      console.log("LH Tree called with callback:: ", false);
    }
  }, [props]);

  useEffect(() => {
    if (JSON.stringify(localPropsObject) !== JSON.stringify(props.props)) {
      setLocalPropsObject(props.props);
      console.log("LH Tree props has changed::", props.props);
      // treeInit();
    }
  }, [props?.props]);

  useEffect(() => {
    // let fullLocationTree = {
    //   ...searchTree(nodes[0], locationMap.rootLocationId),
    // };
    dispatch(updateLocationWrap(fullTreeData[0]));
  }, [fullTreeData]);

  useEffect(() => {
    if (nodes.length === 0) return;
    if (
      (props.props && props.props.filterLocationId === null) ||
      (props.props && props.props.filterLocationId === undefined)
    ) {
      // if(locationMap
      //   && locationMap.rootLocationId) {
      //     setSelectedKey(locationMap.rootLocationId);
      // }
    }
    let selectedLocation = {
      ...searchTree(nodes[0], locationMap.rootLocationId),
    };
    if (props.props && props.props.selectedLocations) {
      preparePreselectedLocations(props.props.selectedLocations, true);
    }
    // selectedLocation.children = null;
    const firstLocation = [selectedLocation];
    if (selectedLocation) {
      if (props.props && props.props.appName === "business-hierarchy") {
        if (
          window.selectedLocationId &&
          window.selectedLocationId !== selectedLocation?.id
        ) {
          setSelectedKey(window.selectedLocationId);
        } else {
          setSelectedKey(selectedLocation?.id);
        }
        if (props.props.treeId) {
          checkLocationChangeAndDispatch(firstLocation, true);
        } else {
          let dispatchLocation = firstLocation;
          if (props.props && props.props.appName === "business-hierarchy") {
            if (
              window.selectedLocationId &&
              window.selectedLocationId !== selectedLocation?.id
            ) {
              setSelectedKey(window.selectedLocationId);
              if (
                locationMap &&
                locationMap.data &&
                locationMap.data.get(window.selectedLocationId)
              ) {
                dispatchLocation = locationMap.data.get(
                  window.selectedLocationId
                );
              }
            }
          }
          dispatch(setSelectedLocations(dispatchLocation));
        }
      }
      // dispatch(updateLocationWrap(firstLocation[0]));
    }
  }, [nodes]);

  const prepareRecursiveTree = (parentId, treeObj = null, recType) => {
    let parentObj = locationMap.data.get(parentId);
    parentObj.key = parentObj.id;
    parentObj.label = parentObj.name;

    if (
      parentObj &&
      parentObj?.type?.includes("FLOOR") &&
      props.props.hasMeetingRoom
    ) {
      let id = String(parentObj.id); // Ensure id is a string
      let filterObject = props.props.meetingRoomData;
      // console.log("parentObjCopy 271", filterObject,parentObj);

      if (filterObject && filterObject[id]) {
        if (parentObj.children === null) {
          parentObj.children = [];
        }

        parentObj.childData = [];

        for (let key in filterObject) {
          if (filterObject.hasOwnProperty(key)) {
            const array = filterObject[key];

            array.forEach((item) => {
              if (item.locationId === id) {
                item.licenseType = parentObj?.licenseType || "";
                item.locationPath = parentObj?.locationPath || [];
                item.locationPathFull = parentObj?.locationPathFull || [];
                item.access = "Full";
                // console.log("parentObjCopy 286",`ID: ${item.locationId}, Name: ${item.name}`);
                parentObj.children.push(item);
              }
            });
          }
        }
      }
    }

    if (parentObj.childData && parentObj.childData.length) {
      parentObj.children = [];
      for (let i = 0; i < parentObj.childData.length; i++) {
        if (
          recType === "appLevel" &&
          props.props.restrictedTypes &&
          props.props.restrictedTypes.length
        ) {
          let childObj = locationMap.data.get(parentObj.childData[i].id);
          if (
            childObj.type &&
            childObj.type.length &&
            childObj.type[0] &&
            props.props.restrictedTypes.indexOf(
              childObj.type[0].toLowerCase()
            ) > -1
          ) {
            // don't add location (restricted type)
          } else {
            parentObj.children.push(
              prepareRecursiveTree(parentObj.childData[i].id, {}, "appLevel")
            );
          }
        } else {
          parentObj.children.push(
            prepareRecursiveTree(parentObj.childData[i].id, {}, "full")
          );
        }
      }
    }
    // console.log("parentObj 305",parentObj);
    return parentObj;
  };

  const togglerTemplate = (node, options) => {
    if (!node) {
      return;
    }

    const expanded = options.expanded;
    let imgSrc = LeafIcon;
    if (node.children && node.children.length) {
      imgSrc = expanded ? CollapseIcon : ExpandIcon;
    }
    // const iconClassName = classNames("p-tree-toggler-icon pi pi-fw", {
    //   "pi-plus-circle": !expanded,
    //   "pi-minus-circle": expanded,
    // });

    return (
      <button
        type="button"
        className="p-tree-toggler p-link"
        tabIndex={-1}
        onClick={options.onClick}
      >
        {/* <span className={iconClassName} aria-hidden="true"></span> */}
        <img src={imgSrc} />
      </button>
    );
  };

  const singleLocationSelection = (e) => {
    let selectedLocation = { ...searchTree(nodes[0], e.value) };
    if (checkActionAllowed(selectedLocation)) {
      const nType = selectedLocation.type[0].toLowerCase();
      if (
        props.props &&
        props.props.filterLocationId &&
        selectedLocation &&
        nType === "root"
      ) {
        return;
      } else if (
        selectedLocation &&
        props.props &&
        props.props.restrictedLocationType &&
        props.props.restrictedLocationType.length &&
        props.props.restrictedLocationType.indexOf(nType) > -1
      ) {
        return;
      } else {
        selectAndDispatchLocation(e, selectedLocation);
      }
    }
  };

  const selectAndDispatchLocation = (e, selectedLocation) => {
    setSelectedKey(e.value);
    // selectedLocation.children = null;
    const selLocation = [selectedLocation];
    if (
      e &&
      e.value &&
      props.props &&
      props.props.appName === "business-hierarchy"
    ) {
      window.selectedLocationId = e?.value;
    }
    if (selectedLocation) {
      if (props.props.treeId) {
        checkLocationChangeAndDispatch(selLocation, false);
      } else {
        dispatch(setSelectedLocations(selLocation));
      }
    }
  };

  const searchTree = (element, matchingId) => {
    if (element && element.id === matchingId) {
      return element;
    } else if (element && element.children != null) {
      var i;
      var result = null;
      for (i = 0; result === null && i < element.children.length; i++) {
        result = searchTree(element.children[i], matchingId);
      }
      return result;
    }
    return null;
  };

  useEffect(() => {
    let selectedLocIdArr = [];
    selectedLocationData.map((loc) => {
      if (loc.id) {
        selectedLocIdArr.push(loc.id);
      }
    });
    setSelectedLocationArray(selectedLocIdArr);
    prepareSelectedParentLocations();
  }, [selectedLocationData]);

  const preparePreselectedLocations = (selectedLocs, dispatchUpdate = true) => {
    setSelectedLocationArray([]);
    setSelectedParentLocationArray([]);
    // setSelectedLocationData([], () => {
    let selectedLocationObjects = [];
    selectedLocs.map((loc) => {
      // if (props.props.hasMeetingRoom) {
      //   let roomObject = props.props.meetingRoomData;
      //   if (roomObject != null) {
      //     const filteredRoomObject = roomObject[loc.locationId].filter(
      //       (item) => item.id === loc.id
      //     );
      //     if (filteredRoomObject.length > 0) {
      //       selectedLocationObjects.push(filteredRoomObject[0]);
      //     }
      //   }
      // } else if (loc.id) {
      //   const selectedLocation = searchTree(nodes[0], loc.id);
      //   selectedLocationObjects.push({ ...selectedLocation });
      // }
      if (props.props.hasMeetingRoom) {
        let roomObject = props.props.meetingRoomData;
        if (roomObject != null && roomObject[loc.locationId] != undefined) {
          const roomObjectArray = roomObject[loc.locationId]; // Access the array for the locationId
          if (Array.isArray(roomObjectArray)) {
            const filteredRoomObject = roomObjectArray.filter(
              (item) => item.id === loc.id
            );
            if (filteredRoomObject.length > 0) {
              selectedLocationObjects.push(filteredRoomObject[0]);
            }
          } else {
            console.info("Error: Expected an array for locationId", roomObject);
          }
        }
      } else if (loc.id) {
        if (nodes && nodes[0]) {
          const selectedLocation = searchTree(nodes[0], loc.id);
          if (selectedLocation) {
            selectedLocationObjects.push({ ...selectedLocation });
          } else {
            console.info("Error: No location found::", loc.id);
          }
        } else {
          setTimeout(() => {
            if (nodes && nodes[0]) {
              const selectedLocation = searchTree(nodes[0], loc.id);
              if (selectedLocation) {
                selectedLocationObjects.push({ ...selectedLocation });
              } else {
                console.info("Error: No location found::", loc.id);
              }
            }
          }, 1000);
        }
      }
    });
    // });
    if (selectedLocationObjects.length && props.props.type === "tick") {
      setSelectedKey(selectedLocationObjects[0].id);
    }
    setSelectedLocationData(selectedLocationObjects);
    setTimeout(() => {
      if (dispatchUpdate) {
        if (props.props.treeId) {
          checkLocationChangeAndDispatch(selectedLocationObjects, true);
        } else {
          dispatch(setSelectedLocations(selectedLocationObjects));
        }
      }
    }, 100);
  };

  const prepareSelectedParentLocations = () => {
    setSelectedParentLocationArray([]);
    let parentLocArray = [];
    if (selectedLocationData.length) {
      selectedLocationData.map((loc) => {
        if (loc.locationPath && loc.locationPath.length) {
          loc.locationPath.map((parentLocId) => {
            if (parentLocArray.indexOf(parentLocId) < 0) {
              parentLocArray.push(parentLocId);
            }
          });
        }
      });
    }
    if (
      locationMap &&
      locationMap.rootLocationId &&
      props.props &&
      (props.props.type === "checkbox" || props.props.type === "tick") &&
      parentLocArray.length
    ) {
      let expandedObj = {};
      expandedObj[locationMap.rootLocationId] = "true";
      parentLocArray.map((locId) => {
        expandedObj[locId] = "true";
      });
      setExpandedKeys(expandedObj);
    }
    setSelectedParentLocationArray(parentLocArray);
  };

  const isNodeSelected = (id) => {
    return selectedKey === id;
  };

  const isNodeChecked = (id) => {
    if (selectedLocationArray && selectedLocationArray.length) {
      if (selectedLocationArray.indexOf(id) > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const isNodeParentOfChecked = (id) => {
    if (selectedParentLocationArray && selectedParentLocationArray.length) {
      if (selectedParentLocationArray.indexOf(id) > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const callbackCheckAndToggle = (node) => {
    if (props.callback !== undefined && props.callback !== null) {
      if (props.callback(node)) {
        toggleLocation(node);
      } else {
        return false;
      }
    } else {
      toggleLocation(node);
    }
  };

  const callbackCheckAndSelect = (e) => {
    if (props.callback !== undefined && props.callback !== null) {
      let node = { ...searchTree(nodes[0], e.value) };
      if (props.callback(node)) {
        singleLocationSelection(e);
      } else {
        return false;
      }
    } else {
      singleLocationSelection(e);
    }
  };

  const toggleLocation = (node) => {
    // console.log("clicked node: ", node);
    if (checkActionAllowed(node)) {
      const nType = node.type[0].toLowerCase();
      setTimeout(() => {
        if (node) {
          if (props.props && props.props.filterLocationId && nType === "root") {
            return;
          } else if (
            props.props &&
            props.props.restrictedLocationType &&
            props.props.restrictedLocationType.length &&
            props.props.restrictedLocationType.indexOf(nType) > -1
          ) {
            return;
          } else {
            prepareDataForSelectedLocations(node);
          }
          // const selLocation = [node];
          // dispatch(updateSelectedLocation( {key: props.props.treeId, value:  selLocation));
        }
      });
    }
  };

  const prepareDataForSelectedLocations = (loc) => {
    // If location already exists, action -> toggleOff: remove from selectedLocations
    let locObjIndex = selectedLocationData.findIndex((n) => n.id === loc.id);
    if (locObjIndex > -1) {
      // remove from selectedlocationsdata object array
      const selObjArray = [...selectedLocationData];
      selObjArray.splice(locObjIndex, 1);
      setSelectedLocationData(selObjArray);

      setTimeout(() => {
        if (props.props.treeId) {
          checkLocationChangeAndDispatch(selObjArray, false);
        } else {
          dispatch(setSelectedLocations(selObjArray));
        }
      }, 100);
    } else {
      // Location doesn't exist already, action -> toggleOn: add to selectedLocations
      // Get list of children locations in existing selected locations-
      // -which have selected location in its location path
      let childrenObjIndex = [];
      let selectLocCopy = [...selectedLocationData];

      selectLocCopy.map((n, i) => {
        if (n.locationPath && n.locationPath.length) {
          if (n.locationPath.indexOf(loc.id) > -1) {
            childrenObjIndex.push(i);
          }
        }
      });
      for (let j = childrenObjIndex.length - 1; j >= 0; j--) {
        selectLocCopy.splice(childrenObjIndex[j], 1);
      }

      // Remove any of the selected location's parent location from selectedlocationdata
      let parentIndex = -1;
      if (loc.locationPath && loc.locationPath.length) {
        for (let i = 0; i < loc.locationPath.length - 1; i++) {
          const pIndex = selectLocCopy.findIndex(
            (n) => n.id === loc.locationPath[i]
          );
          if (pIndex > -1) {
            parentIndex = pIndex;
            break;
          }
        }
      }
      if (parentIndex > -1) {
        selectLocCopy.splice(parentIndex, 1);
      }

      // add selected location to selectedlocationsdata object array
      selectLocCopy.push(loc);
      setSelectedLocationData(selectLocCopy);

      setTimeout(() => {
        if (props.props.treeId) {
          checkLocationChangeAndDispatch(selectLocCopy, false);
        } else {
          dispatch(setSelectedLocations(selectLocCopy));
        }
      }, 100);
      // // prepare selectedLocation array for new selectedlocationdata
      // setSelectedLocationArray([]);
      // let selectedArrayLoc = [];
      // selectLocCopy.map((n) => {
      //   selectedArrayLoc.push(n.id);
      // });
      // setSelectedLocationArray(selectedArrayLoc);

      // // prepare selectedParentLocations for new selectedlocationdata
      // prepareSelectedParentLocations();
    }
  };

  const checkLocationChangeAndDispatch = (selLocation, isFirstTimeLoad) => {
    if (
      parsedLocationTree[props.props.treeId] &&
      parsedLocationTree[props.props.treeId].data &&
      parsedLocationTree[props.props.treeId].data.length === 1
    ) {
      if (
        selLocation[0] &&
        parsedLocationTree[props.props.treeId].data[0] &&
        parsedLocationTree[props.props.treeId].data[0].id === selLocation[0].id
      ) {
        // do nothing
        dispatch(
          updateSelectedLocation({
            key: props.props.treeId,
            value: { firstTimeLoad: isFirstTimeLoad, data: selLocation },
          })
        );
      } else {
        dispatch(
          updateSelectedLocation({
            key: props.props.treeId,
            value: { firstTimeLoad: isFirstTimeLoad, data: selLocation },
          })
        );
      }
    } else {
      dispatch(
        updateSelectedLocation({
          key: props.props.treeId,
          value: { firstTimeLoad: isFirstTimeLoad, data: selLocation },
        })
      );
    }
  };

  const canShowTimeZoneAlert = (node) => {
    if (
      props.props &&
      props.props.appName &&
      props.props.appName !== "business-hierarchy"
    )
      return false;
    else {
      const restrictedLocationTypes = [
        "FLOOR",
        "POLYGON_ZONE",
        "GROUP",
        "AP_ZONE",
      ];
      if (
        node.type &&
        node.type[0] &&
        restrictedLocationTypes.indexOf(node.type[0]) > -1
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  const updateSearch = (e) => {
    if (e && e.target) {
      // console.log("search input::", e.target.value);
      setSearchKey(e.target.value);
      // if (props && props.props.appName === "business-hierarchy") {
      //   if (e.target.value && e.target.value.length > 3) {
      //     searchAps(e.target.value);
      //   } else {
      //     setApList([]);
      //     setShowApDropdown(false);
      //   }
      // }
    }
  };

  // const searchAps = (searchKey) => {
  //   if (searchKey) {
  //     const locationId = locationMap.rootLocationId;
  //     if (locationId) {
  //       LocationService.searchAccessPoints(locationId, searchKey).then(
  //         (response) => {
  //           if (
  //             response.data &&
  //             response.data.apList &&
  //             response.data.apList.length
  //           ) {
  //             setApList(response.data.apList);
  //             setShowApDropdown(true);
  //           }
  //           console.log(response);
  //         }
  //       );
  //     }
  //   }
  // };

  const clearSearch = (e) => {
    console.log("clear input::", e);
    setApList([]);
    setShowApDropdown(false);
    setSearchKey("");
  };

  const filterChanged = (v) => {
    console.log(v);
  };

  const onClickApLocation = (locName) => {
    if (locName && locName.length) {
      setSearchKey(locName);
      setApList([]);
      setShowApDropdown(false);
    } else {
      // loc missing in result
    }
  };

  const isLocationInPath = (nd, restrictedLocs) => {
    let found = false;
    for (let i = 0; i < restrictedLocs.length; i++) {
      if (nd.locationPath && nd.locationPath.indexOf(restrictedLocs[i]) > -1) {
        found = true;
        break;
      }
    }
    return found;
  };

  const checkActionAllowed = (node) => {
    // console.log("props.props.permittedLocationTypes",props.props.permittedLocationTypes);
    if (!props.props.test && props.props.appName === "business-hierarchy") {
      return true;
    }
    if (props.callback !== undefined && props.callback !== null) {
      return props.callback(node);
    }
    let allowedSelection = true;
    if (
      props.props.restrictedLocations &&
      props.props.restrictedLocations.length
    ) {
      if (
        props.props.restrictedLocations.indexOf(node?.id) > -1 ||
        isLocationInPath(node, props.props.restrictedLocations)
      ) {
        // return true;
      } else {
        allowedSelection = false;
      }
    } else if (
      node?.access === undefined ||
      node?.access === null ||
      node?.access === "Read"
    ) {
      allowedSelection = false;
    }
    if (
      props.props.permittedLocationTypes &&
      props.props.permittedLocationTypes.length
    ) {
      if (
        props.props.permittedLocationTypes.indexOf(node.type[0].toLowerCase()) >
        -1
      ) {
        // return true;
      } else {
        allowedSelection = false;
      }
    }
    if (
      props.props.requiredLicenses &&
      props.props.requiredLicenses.length &&
      node.licenseType
    ) {
      // convert requiredLicenses to lower case for comparison
      // Dev NOTE: This change is added due to inconsistency in the case sensitivity of requiredLicenses from apps calling LH2
      const requiredLicensesLower = props.props.requiredLicenses.map((lic) =>
        lic.toLowerCase()
      );
      const licenseTypeLower = node.licenseType.toLowerCase();
      if (requiredLicensesLower.indexOf(licenseTypeLower) > -1) {
        // return true;
      } else {
        allowedSelection = false;
      }
    }
    return allowedSelection;
  };

  const getClassName = (node) => {
    if (checkActionAllowed(node)) {
      return "";
    } else {
      return "node-overlay";
    }
  };

  const getPopoverContent = (
    alrt,
    n,
    hasGenericMessage,
    customTooltipMessage
  ) => {
    return (
      <div className="lhTooltipContent" style={{ zIndex: "999" }}>
        <Text size="p4" weight="semi-bold">
          {n.name}
          {hasGenericMessage && props.props.tooltipMessage ? (
            <Text size="p4">{props.props.tooltipMessage}</Text>
          ) : (
            ""
          )}
          {customTooltipMessage ? (
            <Text size="p4">{customTooltipMessage}</Text>
          ) : (
            ""
          )}
        </Text>
        {alrt ? <Text size="p4">Time zone data not available</Text> : ""}
      </div>
    );
  };

  const nodeTemplate = (node, options) => {
    let label = <b>{node.label}</b>;
    let img = "";
    let showAlert = false;
    let licenseTag = "";

    if (node && node.type) {
      if (!node.inferredTimeZoneId) {
        if (canShowTimeZoneAlert(node)) {
          showAlert = true;
        }
      }
    }

    let showTruncatedName = false;
    let showPopup = false;
    let hasGenericMessage = false;

    let lengthCheck = 30;
    if (node && node.locationPath && node.locationPath.length > 3) {
      lengthCheck = 17;
    }

    if (node && node.name && node.name.length > lengthCheck) {
      showTruncatedName = true;
      showPopup = true;
    }

    let customTooltipMessage = "";
    if (props.props && props.props.tooltipMessage) {
      if (props.callback !== undefined && props.callback !== null) {
        if (!props.callback(node)) {
          showPopup = true;
          hasGenericMessage = true;
        }
      }
    } else {
      if (!checkActionAllowed(node)) {
        if (
          props.props.customTooltip &&
          Object.keys(props.props.customTooltip) &&
          Object.keys(props.props.customTooltip).length
        ) {
          if (props.props.customTooltip.permittedLocationTypes) {
            if (
              props.props.permittedLocationTypes &&
              props.props.permittedLocationTypes.length
            ) {
              if (
                props.props.permittedLocationTypes.indexOf(
                  node.type[0].toLowerCase()
                ) < 0
              ) {
                showPopup = true;
                customTooltipMessage +=
                  " " + props.props.customTooltip.permittedLocationTypes;
              }
            }
          }
          if (props.props.customTooltip.requiredLicenses) {
            if (
              props.props.requiredLicenses &&
              props.props.requiredLicenses.length &&
              node.licenseType
            ) {
              // convert requiredLicenses to lower case for comparison
              // Dev NOTE: This change is added due to inconsistency in the case sensitivity of requiredLicenses from apps calling LH2
              const requiredLicensesLower = props.props.requiredLicenses.map(
                (lic) => lic.toLowerCase()
              );
              const licenseTypeLower = node.licenseType.toLowerCase();
              if (requiredLicensesLower.indexOf(licenseTypeLower) > -1) {
                // return true;
              } else {
                showPopup = true;
                customTooltipMessage +=
                  " " + props.props.customTooltip.requiredLicenses;
              }
            }
          }
          if (props.props.customTooltip.restrictedLocations) {
            if (
              props.props.restrictedLocations &&
              props.props.restrictedLocations.length
            ) {
              if (
                props.props.restrictedLocations.indexOf(node?.id) > -1 ||
                isLocationInPath(node, props.props.restrictedLocations)
              ) {
                // return true;
              } else {
                showPopup = true;
                customTooltipMessage +=
                  " " + props.props.customTooltip.restrictedLocations;
              }
            }
          }
        } else {
          showPopup = true;
          hasGenericMessage = true;
        }
      }
    }

    if (showAlert) {
      showPopup = true;
    }

    if (node.name) {
      let nodeName = showTruncatedName
        ? node.name.substring(0, 27) + "..."
        : node.name;
      if (!showPopup) {
        label = (
          <span
            className="text-700 hover:text-primary"
            rel="noopener noreferrer"
          >
            {nodeName}{" "}
          </span>
        );
      } else {
        label = (
          <Tooltip
            style={{ zIndex: "999" }}
            title={getPopoverContent(
              showAlert,
              node,
              hasGenericMessage,
              customTooltipMessage
            )}
          >
            <span
              className="text-700 hover:text-primary"
              rel="noopener noreferrer"
            >
              {nodeName}{" "}
              {showAlert && (
                <span className="tree-alert">
                  <StatusIcon status="warning" />
                </span>
              )}
            </span>
          </Tooltip>
        );
      }
      // label = (
      //   <span className="text-700 hover:text-primary" rel="noopener noreferrer">
      //     {nodeName}{" "}
      //     {showAlert && (
      //       <span className="tree-alert">
      //         {/* <Popover title={<Text size="p4">Timezone missing</Text>}> */}
      //           <StatusIcon status="warning" />
      //         {/* </Popover> */}
      //       </span>
      //     )}
      //   </span>
      // );
    }

    let locationLabelTemplate = <></>;

    if (props.props && props.props.locationLabel) {
      if (props.props && props.props.locationLabel[node.id]) {
        locationLabelTemplate = (
          <span className="location-label">
            {"(" + props.props.locationLabel[node.id] + ")"}
          </span>
        );
      }
    }

    let dummyLocationCountTemplate = <></>;

    if (dummyTree) {
      if (node.locationBit) {
        dummyLocationCountTemplate = (
          <span className="location-label">{"(" + node.locationBit + ")"}</span>
        );
      }
    }

    if (node.type && node.type && node.type.length) {
      let type = node.type[0].toLowerCase();
      switch (type) {
        case "root":
          img = <img src={RootIcon} />;
          break;
        case "group":
          img = <img src={GroupIcon} />;
          break;
        case "org":
          img = <img src={OrgIcon} />;
          break;
        case "meraki":
          img = <img src={MerakiIcon} />;
          break;
        case "wlc":
          img = <img src={WLCIcon} />;
          break;
        case "campus":
          img = <img src={CampusIcon} />;
          break;
        case "network":
          img = <img src={NetworkIcon} />;
          break;
        case "building":
          img = <img src={BuildingIcon} />;
          break;
        case "floor":
          img = <img src={FloorIcon} />;
          break;
        case "zone":
          img = <img src={ZoneIcon} />;
          break;
        case "polygon_zone":
          img = <img src={ZoneIcon} />;
          break;
        case "ap_zone":
          img = <img src={ApZoneIcon} />;
          break;
        case "outdoor_area":
          img = <img src={OutdoorAreaIcon} />;
          break;
        default:
          break;
      }
    }

    // License Tag from MTag and custom colors from licenseColors in session storage
    // const isSmartLicenseRegistered = sessionStorage.getItem(
    //   "isSmartLicenseRegistered"
    // );
    const licenseDisplayName = JSON.parse(
      sessionStorage.getItem("licenseDisplayName")
    );
    const licenseColors = JSON.parse(sessionStorage.getItem("licenseColors"));
    if (
      licenseColors &&
      Object.keys(licenseColors).length &&
      licenseDisplayName &&
      Object.keys(licenseDisplayName).length &&
      isSmartLicenseRegistered &&
      JSON.parse(isSmartLicenseRegistered) &&
      node.licenseType
    ) {
      licenseTag = (
        <MTag
          size="sm"
          style={{
            marginLeft: 4,
            fontSize: 10,
            color:
              licenseColors[node.licenseType] &&
              licenseColors[node.licenseType].solid
                ? licenseColors[node.licenseType].solid
                : "#444444",
            backgroundColor:
              licenseColors[node.licenseType] &&
              licenseColors[node.licenseType].lighter
                ? licenseColors[node.licenseType].lighter
                : "#FFFFFF",
          }}
        >
          {licenseDisplayName[node.licenseType]}
        </MTag>
      );
    }

    let checkBox = <></>;
    let template = <></>;
    let tick = <></>;

    if (props.props && props.props.type === "checkbox") {
      if (isNodeChecked(node.id)) {
        checkBox = (
          <span className="checkBox">
            <Checkbox
              checked
              onClick={() => callbackCheckAndToggle(node)}
            ></Checkbox>
          </span>
        );
      } else if (isNodeParentOfChecked(node.id)) {
        checkBox = (
          <span className="checkBox">
            <Checkbox
              indeterminate
              onClick={() => callbackCheckAndToggle(node)}
            ></Checkbox>
          </span>
        );
      } else {
        checkBox = (
          <span className="checkBox">
            <Checkbox onClick={() => callbackCheckAndToggle(node)}></Checkbox>
          </span>
        );
      }

      template = (
        <span className={options.className}>
          <span className={getClassName(node)}>
            {img} {label} {locationLabelTemplate} {dummyLocationCountTemplate}{" "}
            {licenseTag}
            {checkActionAllowed(node) && (
              <span className="location-action">{checkBox}</span>
            )}
          </span>
        </span>
      );
    } else if (
      (props.props && props.props.type === "radio") ||
      (props.props && props.props.type === "tick")
    ) {
      tick = isNodeSelected(node.id) ? (
        <span className="tickBox">
          <img src={TickIcon} />
        </span>
      ) : (
        <span className="tickBox"></span>
      );

      template = (
        <span className={options.className}>
          <span className={getClassName(node)}>
            {img} {label} {locationLabelTemplate} {dummyLocationCountTemplate}{" "}
            {licenseTag}
            {checkActionAllowed(node) && (
              <span className="location-action">{tick}</span>
            )}
          </span>
        </span>
      );
    } else {
      template = (
        <span className={options.className}>
          <span className={getClassName(node)}>
            {img} {label}
            {locationLabelTemplate}
            {dummyLocationCountTemplate}
            {licenseTag}
          </span>
        </span>
      );
    }

    return template;
  };

  const searchTemplate = (
    <div className="search-container">
      <Search
        onChange={(e) => {
          updateSearch(e);
        }}
        id="search-location"
        onClear={clearSearch}
        options={[]}
        placeholder="Search"
        value={searchKey}
        label=""
      />
    </div>
  );

  // const getApLocationAndMac = (ap) => {
  //   return ap.name + " (" + ap.macAddress + ")";
  // };

  // const dropdownItemTemplate = (ap, index) => (
  //   <Dropdown.Item
  //     key={index}
  //     onClick={() => {
  //       onClickApLocation(ap.locationDetails.name);
  //     }}
  //     label={getApLocationAndMac(ap)}
  //   />
  // );

  // const searchApTemplate = props.props &&
  //   props.props.appName === "business-hierarchy" && (
  //     <div className="search-results">
  //       <Dropdown label={"Matching APs::" + apList.length}>
  //         {apList.map((ap, index) => dropdownItemTemplate(ap, index))}
  //       </Dropdown>
  //       {/* <div className="matching-results">
  //       Matching APs:: {
  //         apList.length ? `${apList.length}` : ""
  //       }
  //     </div>
  //     {apList.map((ap, index) => (
  //         <div className="search-item"
  //           key={index}
  //           onClick={() => {onClickApLocation(ap.locationDetails.name)}}
  //           >
  //             {ap.locationDetails.name} &gt;
  //         </div>
  //     ))} */}
  //     </div>
  //   );

  const treeTemplate = (
    <div className="lh2-t tree-container">
      <Tree
        value={nodes}
        filter
        onFilterValueChange={filterChanged}
        filterValue={searchKey}
        filterMode="lenient"
        filterPlaceholder="Search Location"
        nodeTemplate={nodeTemplate}
        togglerTemplate={togglerTemplate}
        selectionMode={selectionMode}
        selectionKeys={selectionMode === "single" ? selectedKey : ""}
        onSelectionChange={callbackCheckAndSelect}
        expandedKeys={expandedKeys}
        onToggle={(e) => setExpandedKeys(e.value)}
        className="w-full md:w-30rem"
      />
    </div>
  );

  const treeLoaderTemplate = (
    <div className="treeLoader">
      <MSpinner size="md"></MSpinner>
    </div>
  );

  return (
    <div className="tree-app">
      {showTreeLoader && treeLoaderTemplate}
      {searchTemplate}
      {/* {showApDropdown && searchApTemplate} */}
      {treeTemplate}
    </div>
  );
}
